import { reactive } from 'vue'

const DURATION = 2500

const state = reactive({
  toasts: [],
})

let counter = 0

export const useAlert = message => {
  counter += 1
  const id = counter
  state.toasts.push({ id, message })
  window.setTimeout(() => {
    const index = state.toasts.findIndex(toast => toast.id === id)
    if (index !== -1) state.toasts.splice(index, 1)
  }, DURATION)
}

export const useToasts = () => state
